import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { getSvcGroupList } from '@/api/bairun/svcGroup'; //  此处请自行替换地址

import { getGoodsCategoryList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'SearchTermComponent',
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['allStations', 'allStationMap'])),
  props: ['searchInfo', 'searchMore', 'searchBaseItems', 'btns'],
  data: function data() {
    return {
      searchInfoTemp: {},
      showMore: false,
      showMoreText: '高级搜索',
      showMoreIcon: 'el-icon-caret-bottom',
      payChannelOption: [],
      svcOptTypeOptions: [],
      svcAccountTypeOptions: [],
      svcStatusOptions: [],
      svcGroupOptions: [],
      svcOrderOptTypeOptions: [],
      oilCodesOptions: [],
      categoryOptions: []
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var payChannelList, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              _this2.searchInfoTemp = JSON.parse(JSON.stringify(_this2.searchInfo));

              if (!(_this2.searchInfo.payChannel !== undefined)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return getBairunPayChannelList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 4:
              payChannelList = _context.sent;
              _this2.payChannelOption = payChannelList.data.list;

            case 6:
              if (!(_this2.searchInfo.optType !== undefined)) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return _this2.getDict('svcOptType');

            case 9:
              _this2.svcOptTypeOptions = _context.sent;

            case 10:
              if (!(_this2.searchInfo.accountType !== undefined)) {
                _context.next = 14;
                break;
              }

              _context.next = 13;
              return _this2.getDict('svcAccountType');

            case 13:
              _this2.svcAccountTypeOptions = _context.sent;

            case 14:
              if (!(_this2.searchInfo.svcStatus !== undefined)) {
                _context.next = 18;
                break;
              }

              _context.next = 17;
              return _this2.getDict('svcStatus');

            case 17:
              _this2.svcStatusOptions = _context.sent;

            case 18:
              if (!(_this2.searchInfo.orderOptType !== undefined)) {
                _context.next = 22;
                break;
              }

              _context.next = 21;
              return _this2.getDict('svcOrderOptType');

            case 21:
              _this2.svcOrderOptTypeOptions = _context.sent;

            case 22:
              if (!(_this2.searchInfo.oilCode !== undefined)) {
                _context.next = 26;
                break;
              }

              _context.next = 25;
              return _this2.getDict('oilCode');

            case 25:
              _this2.oilCodesOptions = _context.sent;

            case 26:
              if (!(_this2.searchInfo.ruleType !== undefined)) {
                _context.next = 30;
                break;
              }

              _context.next = 29;
              return _this2.getDict('shopRuleType');

            case 29:
              _this2.shopRuleTypeOptions = _context.sent;

            case 30:
              if (!(_this2.searchInfo.categoryNo !== undefined)) {
                _context.next = 35;
                break;
              }

              _context.next = 33;
              return getGoodsCategoryList({
                'parentNo': 0
              });

            case 33:
              res = _context.sent;
              _this2.categoryOptions = res.data.list;

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    // 表单项重新排序
    var elSearchMore = this.$refs.SearchMore;
    var elForm = this.$refs.SearchFormItems.$el;
    var elFormItems = elForm.children;

    for (var key in this.searchInfo) {
      var formItem = null;

      for (var i = 0; i < elFormItems.length; i++) {
        if (elFormItems[i].getAttribute('name') === key) {
          formItem = elFormItems[i];
          break;
        }
      }

      if (formItem) {
        elForm.appendChild(formItem); // appendChild如果元素已存在则移动该元素
      }
    } // 排序后把按钮移动到表单末尾


    elForm.appendChild(elSearchMore);
  },
  methods: {
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onReset: function onReset() {
      this.searchInfo = Object.assign(this.searchInfo, this.searchInfoTemp);
    },
    onChange: function onChange(formItem) {
      this.$emit('onChange', {
        'name': formItem,
        'value': this.searchInfo[formItem]
      });
    },
    onSearchSvcGroup: function onSearchSvcGroup(query) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getSvcGroupList({
                  groupName: query,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                res = _context2.sent;
                _this3.svcGroupOptions = res.data.list || [];

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};